import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';

import styles from '../assets/styles/components/InputField.module.scss';
import { BASIC_KEYS, NUMBERS, VALID_EMAIL_CHARACTERS } from '../constants/Parameters';
import { execPath } from 'process';

interface Props {
  name: string;
  placeHolder: string;
  numeric?: boolean;
}

export const InputField: React.FC<Props> = (props) => {
  const formic = useFormikContext<any>();
  const [showError, setShowError] = useState(false);
  const [invalid, setInvalid] = useState(false);

  const validate = (key: string) => {
    const defaultValidation = BASIC_KEYS.includes(key);
    if (props.name !== 'email') {
      return defaultValidation || NUMBERS.includes(key);
    } else {
      return defaultValidation || VALID_EMAIL_CHARACTERS.includes(key);
    }
  };

  useEffect(() => {
    validateField();
    // eslint-disable-next-line
  }, [formic.values[props.name]]);
  const validateField = () => {
    const value = formic.values[props.name];
    if (!value) return;
    if (props.name !== 'email') {
      if (!Number(value)) {
        setInvalid(true);
        return;
      }
    }
    setInvalid(false);
  };
  return (
    <div>
      <input
        inputMode={props.numeric ? 'numeric' : 'email'}
        name={props.name}
        data-testid={props.name}
        className={classNames(styles.inputField, invalid && styles.invalid)}
        placeholder={props.placeHolder}
        value={formic.values[props.name]}
        onKeyDown={(e) => {
          if (e.metaKey || e.ctrlKey) return;
          if (!validate(e.key) && e.key !== 'Enter' && e.key !== 'Tab') {
            e.preventDefault();
          }
        }}
        onChange={formic.handleChange}
        onBlur={() => setShowError(true)}
        onFocus={() => setShowError(false)}
      />
      {showError ? <div className={styles.error}>{formic.errors[props.name]}</div> : <></>}
    </div>
  );
};
